"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const forms_1 = require("@rebass/forms");
const rebass_1 = require("rebass");
const styled_components_1 = __importDefault(require("styled-components"));
function default_1(_a) {
    var { label, value, onChange = () => { }, prefix, suffix, error } = _a, rest = __rest(_a, ["label", "value", "onChange", "prefix", "suffix", "error"]);
    return (react_1.default.createElement(rebass_1.Box, { className: "form-element", mb: 2 },
        react_1.default.createElement(rebass_1.Text, { fontWeight: 500, fontSize: 13, color: rest.disabled ? "#aaa" : undefined }, label),
        react_1.default.createElement(Relative, null,
            prefix && react_1.default.createElement(Prefix, null, prefix),
            react_1.default.createElement(forms_1.Input, Object.assign({}, rest, { value: value, onChange: onChange, css: { zIndex: 1 }, className: error ? "error" : "" })),
            suffix && react_1.default.createElement(Suffix, null, suffix)),
        react_1.default.createElement(Error, null, error)));
}
exports.default = default_1;
const Relative = styled_components_1.default.div({
    position: "relative",
    display: "flex",
    marginTop: 5,
});
const Prefix = styled_components_1.default.div({
    minWidth: 40,
    borderRadius: "6px 0 0 6px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#eeeeee",
    marginRight: -5,
    paddingRight: 5,
});
const Suffix = styled_components_1.default.div({
    minWidth: 40,
    borderRadius: "0px 6px 6px 0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#eeeeee",
    marginLeft: -5,
    paddingLeft: 5,
    zIndex: 0,
});
const Error = styled_components_1.default.div `
    color: red;
    font-size: 12px;
    font-weight: 500;
`;
//# sourceMappingURL=TextInput.js.map